import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Button, Form, InputGroup } from "react-bootstrap";
import apiService from '../../services/api.services';
import { jwtDecode as jwt_decode } from 'jwt-decode';
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import JSBI from "jsbi";
// const { base62Encode } = require('../utils/encryptorUtils');

function PreloadingApproval() {
  const [series, setSeries] = useState("");
  const [approvalid, setApprovalid] = useState("");

  const { approvalRole, encParam } = useParams();
 
  const [response, setResponse] = useState("");
  const [rejectionMessage, setRejectionMessage] = useState("");
  const [approvalMessage, setApprovalMessage] = useState("");
  const [showThankYou, setShowThankYou] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    try {
      
      const decoded = jwt_decode(encParam);
        setSeries(decoded.formseriesSent);
        setApprovalid(decoded.approvalidSent);

      console.log("Decrypted:", decoded);
    } catch (error) {
      console.error("Decryption error:", error);
    }
  }, []);

  useEffect(() => {

    const decoded = jwt_decode(encParam);
    const formseriesSent = decoded.formseriesSent;

    apiService.confirmedAppv(formseriesSent).then((response) => {
        
        const status = response.data.appvStatus;

        if ( approvalRole === "TEAM LEADER" && (status.appvTeamLeaderStatus === "Approved" || status.appvTeamLeaderStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "BRANCH HEAD" && (status.appvBranchHeadStatus === "Approved" ||status.appvBranchHeadStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "REGION BUSINESS HEAD" && (status.appvRegionBusinessHeadStatus === "Approved" || status.appvRegionBusinessHeadStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "BUSINESS FINANCE" && (status.appvBusinessFinanceStatus === "Approved" || status.appvBusinessFinanceStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "EXPORT COMPLIANCE" && (status.appvExportComplianceStatus === "Approved" || status.appvExportComplianceStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "CREDIT INSURANCE" && (status.appvCreditInsuranceStatus === "Approved" || status.appvCreditInsuranceStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "CEO" && (status.appvCEOStatus === "Approved" || status.appvCEOStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "COO" && (status.appvCOOStatus === "Approved" || status.appvCOOStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "CFO" && (status.appvCFOStatus === "Approved" || status.appvCFOStatus === "Rejected")) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        } else if ( approvalRole === "SVP-DIRECTOR" && (status.appvSVPDirectorStatus === "Approved" || status.appvSVPDirectorStatus === "Rejected") ) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        }
      })
      .catch((error) => {
        setError(error);
      });
  }, [approvalRole, series]);

  const handleApprove = (e) => {

    if (approvalMessage === "") {
       e.preventDefault();
      let approvalStatus = "Approved";
      let approvalMessage = "Deal Approved";

      apiService
        .finalApproval(
          series,
          approvalStatus,
          approvalMessage,
          rejectionMessage,
          approvalRole,
          approvalid
        )
        .then((response) => {
          console.log(":::::Aprroval Approved:::::", response.data);
          setResponse("Thank you for your approval!");
          setShowThankYou(true);
        })
        .catch((error) => {
          setError(error);
        });
    } else {
      e.preventDefault();
      let approvalStatus = "Approved";
      
      apiService
        .finalApproval(
          series,
          approvalStatus,
          approvalMessage,
          rejectionMessage,
          approvalRole,
          approvalid
        )
        .then((response) => {
          console.log(":::::Aprroval Approved:::::", response.data);
          setResponse("Thank you for your approval!");
          setShowThankYou(true);
        })
        .catch((error) => {
          setError(error);
        });
    }
  };

  const handleReject = (e) => {
    if (rejectionMessage === "") {
      toast.error("Please provide a valid rejection reason ");
    } else {
      e.preventDefault();
      let approvalStatus = "Rejected";
      apiService
        .finalApproval(
          series,
          approvalStatus,
          approvalMessage,
          rejectionMessage,
          approvalRole,
          approvalid
        )
        .then((response) => {
          console.log(":::::Aprroval Rejected:::::", response.data);
          setResponse("Thank you for your response!");
          setShowThankYou(true);
        })
        .catch((error) => {
          setError(error);
        });
    }
  };

  const handleRedirectToLogin = () => {
    navigate("/");
  };

  if (error) return <h1>Error: {error.message}</h1>;
  return (
    <Container className="pt-5 mb-4">
      {!showThankYou ? (
        <>
          <Col className="d-flex justify-content-center pt-5 mt-5">
            <h3>Please Provide Feedback</h3>
          </Col>
          <Row className="pt-4 justify-content-center">
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Approval message"
                  value={approvalMessage}
                  onChange={(e) => setApprovalMessage(e.target.value)}
                />
                <Button variant="success" onClick={handleApprove}>Approve</Button>
              </InputGroup>
          </Row>
          <Row className="pt-4 justify-content-center">
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Rejection message"
                value={rejectionMessage}
                onChange={(e) => setRejectionMessage(e.target.value)}
              />
              <Button variant="danger" onClick={handleReject}>Reject</Button>
            </InputGroup>
          </Row>
        </>
      ) : (
        <div className="pt-5 mt-5">
          <Col className="d-flex justify-content-center pb-5">
            <h1 style={{ color: "Green" }}>{response}</h1>
          </Col>
          <Col className="d-flex justify-content-center">
            <p>Click below to login back to portal</p>
          </Col>
          <Col className="d-flex justify-content-center">
            <Button variant="primary" onClick={handleRedirectToLogin}>
              Login
            </Button>
          </Col>
        </div>
      )}
    </Container>
  );
}

export default PreloadingApproval;
